import { useCallback, useMemo } from 'react';
import { isFeatureEnabled as isFeatureEnabledUtil } from '../utils';
import { ReactContextProvider } from './context';
import { FeatureFlagsContextProps as ContextProps } from './types';

export const FeatureFlagsProvider = ({ children, value }: ContextProps) => {
  const isFeatureEnabled = useCallback(
    (feature?: string) => {
      return isFeatureEnabledUtil(value?.config, feature);
    },
    [value?.config]
  );

  const memoizedValue = useMemo(
    () => ({ isFeatureEnabled }),
    [isFeatureEnabled]
  );

  return (
    <ReactContextProvider value={memoizedValue}>
      {children}
    </ReactContextProvider>
  );
};
